"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FilterChip = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _ChipLabel = require("../AssistChip/ChipLabel");
var _FilterChip = require("./FilterChip.styles");
var _excluded = ["buttonType", "children", "chipElevation", "disabled", "icon", "iconPosition", "iconSize", "inverse", "size"];
/**
 * Filter chips are toggles used mainly for filtering and sorting content (ex: search filters).
 *
 * @extends ToggleButton
 * @related ['AssistChip', 'Checkbox', 'InputChip', 'Switch']
 * @since 8.97.0
 */
var FilterChip = /*#__PURE__*/(0, _react.forwardRef)(function (props, forwardedRef) {
  var buttonType = props.buttonType,
    children = props.children,
    chipElevation = props.chipElevation,
    disabled = props.disabled,
    icon = props.icon,
    iconPosition = props.iconPosition,
    iconSize = props.iconSize,
    inverse = props.inverse,
    size = props.size,
    rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  return /*#__PURE__*/_react.default.createElement(_FilterChip.StyledFilterChip, (0, _extends2.default)({
    buttonType: "tertiary",
    chipElevation: chipElevation,
    disabled: disabled,
    icon: icon,
    iconPosition: "start",
    iconSize: "xs",
    ref: forwardedRef,
    type: "button"
  }, rest), /*#__PURE__*/_react.default.createElement(_ChipLabel.ChipLabel, null, children));
});
exports.FilterChip = FilterChip;
FilterChip.displayName = 'FilterChip';
FilterChip.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The assist chip’s text label. To add decorators, use the `icon` and `avatar` props.
   */
  children: _propTypes.default.node.isRequired,
  /**
   * When true, adds a drop shadow. Useful for making the assist chip easier to see on
   * certain backgrounds (ex: on top of a photo or map)
   */
  chipElevation: _propTypes.default.bool,
  /**
   * Sets the assist chip as disabled.
   */
  disabled: _propTypes.default.bool,
  /**
   * Adds a leading icon. Takes an `Icon` component but ignores its `size` prop
   * (i.e. the icon size is fixed). Does not support `DetailedIcon`.
   */
  icon: _propTypes.default.node
} : {};
FilterChip.defaultProps = {
  chipElevation: false,
  disabled: false,
  icon: null
};